import { Back, Bounce, TweenMax, gsap } from "gsap/all"
import React, { Component } from "react"

import CloseIcon from "../images/icons/close.inline.svg"
import { ContactUsModal } from "./contactUsModal"
import FullstackIcon from "../images/icons/fullstack-logo.svg"
import Layout from "./layout"
import Modal from "react-modal"
import PropTypes from "prop-types"
import Seo from "gatsby-plugin-wpgraphql-seo"
import TrainingCard from "./card/trainingCard"
import StackCard from "./card/stackCard"
import { isImageSquare } from "../util/isImageSquare"

Modal.setAppElement("#___gatsby")

const modalStyles = {
  overlay: {
    backgroundColor: "rgba(0, 0, 0, 0.58)",
    zIndex: "999",
  },
  content: {
    position: "fixed",
    top: "0",
    left: "0",
    right: "0",
    bottom: "0",
    maxWidth: "1134px",
    margin: "50px auto",
    padding: 0,
    border: 0,
    overflow: "hidden",
    borderRadius: "8px",
    boxShadow: "0 2px 4px 0 rgba(0, 0, 0, .25)",
  },
}
class StackLayout extends Component {
  constructor(props) {
    super(props)
    this.bgAnimate = null
    this.bgTween = null
    this.svgTl = gsap.timeline({ paused: false })
    this.svg = null
    this.headAnimate = null
    this.headTween = null
    let showModal = false
    let showContactModal = false

    this.state = {
      play: "",
      showModal: showModal,
      showContactModal: showContactModal,
      cardTitle: ""
    }
  }

  setCardTitle(cardTitle) {
    this.setState({ cardTitle })
  }

  handleOpenModal = () => {
    this.setState({ showModal: true })
  }

  handleCloseModal = () => {
    this.setState({ showModal: false })
  }

  handleOpenContactModal = () => {
    this.setState({ showContactModal: true })
  }

  handleCloseContactModal = () => {
    this.setState({ showContactModal: false })
  }

  handlePlay() {
    this.setState({
      play: this.state.play === "?autoplay=1" ? "" : "?autoplay=1",
    })
  }

  /*
  * Checks if the youtube url provided has a "v=" parameter, and return the proper embed url
  */
  youtubeVideoSrc () {
    const url = new URL(this.props.postData.acf.videoTutorial);
    const urlParams = new URLSearchParams(url.search)
    const ytVideoId = urlParams.get('v')
    let embedUrl = '';

    embedUrl = ytVideoId ? `https://www.youtube.com/embed/${ytVideoId}` : this.props.postData.acf.videoTutorial
    return embedUrl
  }

  componentDidMount() {
    this.bgTween = TweenMax.from(".bg-animate", 0.7, {
      height: 0,
      top: "30%",
      delay: 0,
      ease: Bounce.easeOut,
    })
    this.headTween = TweenMax.from(".head-animate", 1, {
      css: { top: "150px", scale: 0.2, opacity: 0 },
      ease: Back.easeOut,
    })
    this.svgTl.from(this.svg, 0.6, {
      rotation: 70,
      transformOrigin: "center center",
      delay: 0.5,
      opacity: 0,
    })
  }

  render() {
    const { title, content, acf, id } = this.props.postData
    const { play, cardTitle } = this.state
    const relatedContent = this.props.allPosts
    const hasHeading =  relatedContent.map(related => (
       [  ...(related?.node?.acf?.tenjinRelatedContent
                              ? related.node.acf.tenjinRelatedContent.map(
                                  icon => {
                                    return icon.id === id
                                  }
                                )
                              : []),
                              ...(related.node.acf.tenjinCardTechnologyIcons !== null && related.node.acf.tenjinCardTechnologyIcons !== undefined
                              ? related.node.acf.tenjinCardTechnologyIcons.map(
                                  icon => {
                                    return icon.id === id
                                  }
                                )
                              : []),
                          ]
    ))
    .map(hasRelated =>
      (hasRelated.some(x => x === true)) ? true : false
      )
    .some(x => x === true)

    return (
      <Layout>
        <Seo post={this.props.postData} />
        <div className="overflow-hidden">
          <div className="relative z-20" style={{minHeight: 520}}>
            <div
              style={{ height: "100%" }}
              className="absolute top-0 left-0 w-full h-full bg-bottom bg-no-repeat bg-hero-pattern bg-nav-primary"
              ref={div => (this.bgAnimate = div)}
            ></div>
            <div className="z-40 px-6 mx-auto max-w-screen-2xl md:max-w-2xl lg:max-w-4xl xl:max-w-7xl 2xl:max-w-screen-2xl">
              <div className="relative w-4/5 pt-24">
                <div className="relative">
                  <h1
                    className="text-gray-900 headline-1"
                    dangerouslySetInnerHTML={{ __html: acf.tenjinPageTitle ? acf.tenjinPageTitle : title }}
                  ></h1>
                </div>
                <div className="mt-5 mr-5 overflow-hidden">
                  <div className="flex items-center w-full h-full">
                    <img
                      className={`${
                        isImageSquare(acf?.iconColor?.mediaDetails?.width, acf?.iconColor?.mediaDetails?.height)
                        ? "w-16 h-16"
                        : "h-16"
                        }`}
                      alt={title}
                      title={title}
                      src={acf?.iconColor?.sourceUrl}
                    />
                  </div>
                </div>
                <div ref={div => (this.cat = div)} className="mt-2">
                  <div className="inline-block w-3/5 text-2xl rounded-full font-regular py-2px text-nav-active">
                    <p dangerouslySetInnerHTML={{ __html: acf?.tenjinHeadline }}></p>
                  </div>
                </div>
                <button
                  onClick={this.handleOpenContactModal.bind(this)}
                  className="px-8 py-2 mt-5 text-xl font-bold text-white rounded bg-primary w-content"
                >
                  Book a demo
                </button>
                {this.state.showContactModal &&
                  <ContactUsModal
                    showModal={this.state.showContactModal}
                    setShowModal={this.handleCloseContactModal.bind(this)}
                    headline={`Are you ready to gain more insight into your marketing data?<br/><br/>
                    Book a demo with our team to get a personalized tour of our platform and take the opportunity to get a free trial using two weeks' worth of your data after the demo.<br/><br/>
                    If you cannot find a time slot that suits you here, feel free to send us an email with your availabilities at <a class='underline' href='mailto:info@growthfullstack.com'>info@growthfullstack.com</a>, and we will get back to you ASAP.`}
                    btnText="Book a Demo"
                    subject="Demo Request"
                  /> }
              </div>
            </div>
          </div>
          
          <div className="z-30 mx-auto max-w-screen-2xl">
            
              {hasHeading && (
                <div className="pt-2 pb-6 space-y-6 mx-6 py-14 md:mx-auto md:max-w-2xl lg:max-w-4xl xl:max-w-7xl 2xl:max-w-screen-2xl">
                  <div className="flex justify-between">
                    <p className="text-4xl-m font-black text-font-primary">Use Cases</p>
                  </div>
                  <div className="mx-auto">
                    <div className="lg:-mx-gutter">
                    <div className="gap-4 stack--pages__main-container-training--layout">
                        {relatedContent.map(related => {

                          const hasRelation =
                          [  ...(related?.node?.acf?.tenjinRelatedContent
                              ? related.node.acf.tenjinRelatedContent.map(
                                  icon => {
                                    return icon.id === id
                                  }
                                )
                              : []),
                          ]
                          if (
                            hasRelation.some(x => x === true) &&
                            (related.node.nodeType === "Training")
                          ) {
                            return (
                              <div className="max-width-max-content">
                                <TrainingCard
                                  cardWidth="w-full"
                                  cardData={related}
                                  setCardTitle={this.setCardTitle.bind(this)}
                                  cardTitle={cardTitle}
                                  key={related.databaseId}
                                />
                              </div>
                            )
                          } else {
                            return false
                          }
                        })}
                      </div>
                    </div>
                  </div>
                  <div className="flex justify-between">
                    <p className="text-4xl-m font-black text-font-primary">Tutorials</p>
                  </div>
                  <div className="mx-auto">
                    <div className="lg:-mx-gutter">
                    <div className="gap-4 stack--pages__main-container-training--layout">
                        {relatedContent.map(related => {

                          const hasRelation =
                          [  ...(related?.node?.acf?.tenjinRelatedContent
                              ? related.node.acf.tenjinRelatedContent.map(
                                  icon => {
                                    return icon.id === id
                                  }
                                )
                              : []),
                          ]
                          if (
                            hasRelation.some(x => x === true) &&
                            (related.node.nodeType === "Tutorial")
                          ) {
                            return (
                              <div className="max-width-max-content">
                                <TrainingCard
                                  cardWidth="w-full"
                                  cardData={related}
                                  setCardTitle={this.setCardTitle.bind(this)}
                                  cardTitle={cardTitle}
                                  key={related.databaseId}
                                />
                              </div>
                            )
                          } else {
                            return false
                          }
                        })}
                      </div>
                    </div>
                  </div>
                </div>
              )}
            
            <div className="flex flex-col justify-between mx-6 md:mx-auto lg:flex-row py-14 md:max-w-2xl lg:max-w-4xl xl:max-w-7xl 2xl:max-w-screen-2xl">
              <div className="w-full pr-6 lg:w-3/4 lg:pr-28">
                
                <div
                  className="text-lg stack-content wysiwyg"
                  dangerouslySetInnerHTML={{ __html: content }}
                ></div>
              </div>

              {(acf.resources || acf.videoTutorial || acf.tenjinRelatedContent ) && (<div className="z-10 mx-1 lg:w-64 lg:ml-16 ">
                <div className="z-10 lg:w-64 ">
                 
                  {/* Related Content*/}
                  {acf.resources && (
                    <div className="space-y-8 mb-8">
                      <div className="w-60">
                        <h3 className="pb-6 text-lg text-xl font-black text-gray-300">
                          {title} Documentation
                        </h3>
                      </div>
                      {acf.resources.length > 0 &&
                        acf.resources.map((res, index) => (
                          <div
                            key={index}
                            className="px-16 text-xl text-center text-black underline bg-white rounded-lg shadow-cardTag w-60"
                          >
                            <a href={res.url} target="_blank" rel="noreferrer">{res.text}</a>
                          </div>
                        ))}
                    </div>
                  )}
                  {acf.videoTutorial && (
                    <div class="mb-8">
                      <h3 className="pb-6 text-lg text-xl font-black text-gray-300">
                        Video
                      </h3>
                      <div
                        role="button"
                        tabIndex={0}
                        aria-hidden="true"
                        onClick={this.handleOpenModal.bind(this)}
                        className="p-2 text-xl text-center text-black underline bg-white rounded-lg outline-none shadow-cardTag w-60 h-video focus:outline-none"
                      >
                        <iframe
                          title="youtube"
                          className="w-full h-full youtube"
                          src={`${this.youtubeVideoSrc()}${play}`}
                          frameBorder="0"
                          allowFullScreen={true}
                          allow="accelerometer; modestbranding; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        ></iframe>
                      </div>
                    </div>
                  )}
                  {acf?.tenjinRelatedContent?.length > 0 && (
                    <div className="z-30 max-w-screen-xl lg:max-w-xs">
                      <h3 className="pb-6 text-lg text-xl font-black text-gray-300">Connect with</h3>
                      {/* <Slider arrows={false} {...settings} className=""> */}
                        <div className="gap-4 stack--pages__main-container-training--layout">
                        {acf.tenjinRelatedContent?.map(related => {
                          if (
                            ( (related.nodeType && related.nodeType === "Training") || (related.uri && related.uri.includes("/training/")) ) ||
                            ( (related.nodeType && related.nodeType === "Tutorial") || (related.uri && related.uri.includes("/tutorial/")) )
                          )
                          {
                            return (
                              <div className="mb-2 max-width-max-content">
                                <TrainingCard
                                  cardWidth="w-full"
                                  cardData={{ node: related }}
                                  setCardTitle={this.setCardTitle.bind(this)}
                                  cardTitle={cardTitle}
                                  key={related.databaseId}
                                />
                              </div>
                            )
                          }
                          if (
                            ( (related.nodeType && related.nodeType === "Analyse") || (related.uri && related.uri.includes("/analyse/")) ) ||
                            ( (related.nodeType && related.nodeType === "Destination") || (related.uri && related.uri.includes("/destination/")) ) ||
                            ( (related.nodeType && related.nodeType === "Source") || (related.uri && related.uri.includes("/source/")) )
                          ) {
                            return (
                              <div className="mb-7 max-width-max-content">
                                <StackCard
                                  cardWidth="w-full"
                                  cardData={{ node: related }}
                                  key={related.databaseId}
                                  cardIndex={related.databaseId}
                                  renderSmallCard={false}
                                />
                              </div>
                            )
                          }
                          return []
                        })}
                        </div>
                      {/* </Slider> */}
                        </div>
                  )}
                  
                </div>
              </div>
              )}
            </div>
          </div>

          {acf.getMoreOut && (
            <div className="bg-get-more-primary">
              <div className="">
                <div className="w-3/5 pt-20 pb-20 m-auto space-y-10 lg:pt-38">
                  <h3 className="text-4xl font-black leading-snug text-center text-white lg:text-5xl">
                    Get the most out of {title} <br/> with <span className="text-4xl text-transparent lg:text-5xl bg-clip-text bg-gradient-to-r from-title-from to-title-to">Growth Fullstack</span>
                  </h3>
                </div>
                <div className="flex flex-col items-center content-center pb-20 mx-auto lg:pb-40 lg:justify-center lg:flex-row max-w-screen-2xl md:flex-col xl:flex-row lg:px-0 lg:max-w-4xl xl:max-w-7xl 2xl:max-w-screen-2xl ">
                  <div className="flex flex-col items-center px-5 py-6 rounded xl:flex-row get-more-bg lg:px-36 lg:py-32 w-content">
                    <div className="items-center py-4 w-60">
                      <div className="flex w-32 h-32 m-auto">
                        <img
                          className="object-contain w-full h-full"
                          alt={title}
                          title={title}
                          src={acf?.iconColor?.sourceUrl}
                        />
                      </div>
                    </div>
                    <p className="my-auto text-4xl font-black text-white mx-11">
                      +
                    </p>
                    <div className="items-center py-4 w-60">
                      <div className="flex w-32 h-32 m-auto">
                        <img src={FullstackIcon} className="object-contain w-full h-full" alt="FS"/>
                      </div>
                    </div>
                  </div>
                  <div className="my-auto text-2xl font-light text-white lg:ml-10">
                    <h6>
                      <div
                        className="p-5 pt-16 lg:pt-0 text-2xl stack-content wysiwyg xl:text-left"
                        dangerouslySetInnerHTML={{ __html: acf.getMoreOut }}
                      ></div>
                    </h6>
                  </div>
                </div>
              </div>
            </div>
          )}
          <Modal style={modalStyles} isOpen={this.state.showModal}>
            <button
              className="absolute top-0 right-0 mt-6 mr-8 outline-none focus:outline-none"
              onClick={this.handleCloseModal}
            >
              <CloseIcon className="fill-current text-gray-silver"></CloseIcon>
            </button>
            <div className="w-full h-full pt-16 bg-white rounded-lg p-7">
              <iframe
                title="youtube"
                className="w-full h-full"
                src={`${acf.videoTutorial}`}
                frameBorder="0"
                allow="accelerometer; modestbranding; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              ></iframe>
            </div>
          </Modal>
        </div>
      </Layout>
    )
  }
}

StackLayout.propTypes = {
  postData: PropTypes.object,
}

StackLayout.defaultProps = {
  postData: ``,
}

export default StackLayout
